/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react'
import { withTranslation } from 'react-i18next'

import './SessionPopover.scss'

class SessionPopover extends React.Component {
  UNSAFE_componentWillMount() {
    document.addEventListener('click', this._handleClick, false)
  }
  componentWillUnmount() {
    document.removeEventListener('click', this._handleClick, false)
  }

  render() {
    const { t } = this.props
    return (
      <div
        id='SessionPopover'
        ref={node => (this.node = node)}
        onClick={this._anotherClick}
      >
        <p className='duplicate-session' onClick={this._duplicate}>
          {t('lessonPlans.sessionPopover.duplicateSession')}
        </p>
        <p className='delete-session' onClick={this._delete}>
          {t('lessonPlans.sessionPopover.deleteSession')}
        </p>
      </div>
    )
  }

  _duplicate = e => {
    e.stopPropagation()
    const { index } = this.props
    this.props.duplicate(index)
  }

  _delete = e => {
    e.stopPropagation()
    const { index } = this.props
    this.props.delete(index)
  }

  _handleClick = e => {
    // just tracks if the user clicks outside the component to close the popover
    if (!this.node.contains(e.target)) {
      this.props.close()
    }
  }

  _anotherClick = e => {
    // stops from click event on whitespace of component selecting this session to display on the page
    e.stopPropagation()
  }
}

export default withTranslation()(SessionPopover)
